import React, { useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useEffect } from "react";
import axiosauth from "../../axios-config-auth";
import Loader from "react-loader-spinner";
import close from "../../assets/icons/close.png";
import NoData from "../../components/halper/NoData";
import editIcon from "../../assets/icons/edit.png";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import Layout from "../../layout/layout";
import { confirmAlert } from 'react-confirm-alert';
import deleteIcon from '../../assets/icons/delete.png';

const Offer = () => {
    const [Offer, setOffer] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState("");

    const handleEditClose = () => setShowEditModal(false);
    const handleEditShow = () => setShowEditModal(true);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editName, setEditName] = useState("");
    const [editId, setEditId] = useState("");


    const loadOffer = () => {
        axiosauth
            .post("/sticky/load", { limit: 1000 })
            .then(async (response) => {
                let res = JSON.parse(response.data);
                console.log("load response------->>" , res)
                if (res.status === "true") {
                    setOffer(res.data);
                    console.log("response---->>", res.data)
                    setShowLoader(false);
                } else {
                    setShowLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        setShowLoader(true);
        loadOffer();
    }, []);

    const handleSubmit = () => {
        const obj = {
            name: name,
        };
        axiosauth
            .post("/sticky/create", obj)
            .then(async (response) => {
                console.log("response--------->>" , response)
                const res = JSON.parse(response.data)
                if (res.status === 'true') {
                    handleClose();
                    loadOffer()
                } else {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleEditChange = () => {
        axiosauth
            .post("/sticky/sticky-update", { name: editName, stickyId: editId })
            .then(async (response) => { 
                const res = JSON.parse(response.data)
                if (res.status === "true") {
                    handleEditClose();
                    loadOffer()
                } else {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <Layout>
            <div
                className="left_arrow2 back-arrow mt-3"
                style={{
                    display: "flex",
                    alignItems: "baseline",
                    fontFamily: "inherit",
                }}>
                <h2>Sticky Offer</h2>
                <div className="button">
                    <button onClick={() => handleShow()}>Add Offer</button>
                </div>
            </div>

            <Modal show={showModal} backdrop="static" onHide={handleClose}>
                <Modal.Header className="border-0">
                    <Modal.Title>Offer Name</Modal.Title>
                    <div className="d-end" onClick={handleClose} style={{ cursor: "pointer" }}>
                        <img
                            src={close}
                            alt="close.jpg"
                            style={{ height: "15px", width: "15px" }}
                        />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p>Offer Heading</p>
                    <input
                        type="text"
                        style={{ width: "100%" }}
                        className="form-control"
                        placeholder="Enter Offer Heading"
                        onChange={(e) => setName(e.target.value)}
                    />

                    <Button className="button  btn-dark" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>

            {/* ================== Edit Offer ==================== */}
            <Modal show={showEditModal} backdrop="static" onHide={handleEditClose}>
                <Modal.Header className="border-0">
                    <Modal.Title>Edit Offer</Modal.Title>
                    <div className="d-end" onClick={handleEditClose} style={{ cursor: "pointer" }}>
                        <img src={close} alt="img" height={20} />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p>Offer Name</p>
                    <div className="d-flex" style={{ justifyContent: "space-around" }}>
                        <input
                            type="text"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                            style={{ width: "70%" }}
                            className="form-control"
                        />
                        <Button
                            variant="primary"
                            style={{ backgroundColor: "#333333", width: "25%" }}
                            onClick={handleEditChange}
                        >
                            Save
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>

            {!showLoader ? (
                <div className="table-wrap overflow-auto table-responsive card py-2 " style={{ height: "500px" }}>
                    <table>
                        {Offer && Offer.length > 0 ? (<thead>
                            <tr>
                                <th>S.No</th>
                                <th >Offer Name</th>
                                <th>Actions</th>
                            </tr>
                        </thead>) : null}
                        <tbody>
                            {Offer && Offer.length > 0 ?

                                Offer.map((item, index) => {

                                    const deleteExplore = () => {
                                        let obj = {
                                            stickyId: item._id,
                                        }
                                        confirmAlert({
                                            // title: 'Change Status',
                                            message: 'Are you sure you want to delete this Offer ?',
                                            buttons: [
                                                {
                                                    label: 'Yes',
                                                    onClick: () => {
                                                        axiosauth.post('/sticky/sticky-delete', obj)
                                                            .then(async (response) => {
                                                                // console.log("delete Offer---->>", response)
                                                                // const res = JSON.parse(response.data)

                                                                let res = JSON.parse(response.data)
                                                                if (res.status === "true") {
                                                                    loadOffer()
                                                                } else {
                                                                }
                                                            })
                                                            .catch((error) => {
                                                                console.log(error);
                                                            })
                                                    }
                                                },
                                                {
                                                    label: 'No',
                                                    onClick: () => console.log("Hello")
                                                }
                                            ]
                                        });

                                    }


                                    return (
                                        <tr key={index}>
                                            <td>{(index + 1)}</td>
                                            <td className="titleStyle title-name" >{item.name}</td>
                                            <td>
                                                <img onClick={() => {
                                                    handleEditShow();
                                                    setEditName(item.name);
                                                    setEditId(item._id);
                                                }} src={editIcon} alt="edit-button" className="edit-icon" />
                                                {/* </Link> */}

                                                <img onClick={() => deleteExplore()} src={deleteIcon} alt="delete" className="delete-icon" />
                                            </td>
                                        </tr>
                                    )
                                })

                                :
                                (<NoData message=" Offer Not Found" />
                                )
                            }

                        </tbody>
                    </table>

                </div>
            ) : (
                <div className="loader-style">
                    <Loader
                        type="ThreeDots"
                        color="rgba(32, 159, 132, 1)"
                        height={100}
                        width={100}
                        timeout={500000}
                    />
                </div>
            )}
        </Layout>
    );
};

export default Offer;
